import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBars, FaMapMarkerAlt, FaBell, FaUser } from 'react-icons/fa';
import { IoIosClose } from 'react-icons/io';

import SideMenuList from './side-menu/SideMenuList';
import NotificationsMenu from '../../client/js/component/dump/NotificationsMenu';
import UserAccountMenu from '../../client/js/component/dump/UserAccountMenu';

import './MobileBottomNav.sass';

const MobileBottomNav = () => {
	const navigate = useNavigate();
	const [menuOpen, setMenuOpen] = useState(false);
	const [notificationsOpen, setNotificationsOpen] = useState(false);
	const [profileOpen, setProfileOpen] = useState(false);
	const anyPanelOpen = menuOpen || notificationsOpen || profileOpen

	return (
		<>
			<nav className={`bottom-nav-mobile ${anyPanelOpen ? 'hidden' : ''}`} aria-label="Mobile navigation">
				<button
					type="button"
					className="bottom-nav-item"
					aria-label="Menu"
					onClick={() => setMenuOpen(!menuOpen)}
				>
					<FaBars />
				</button>
				<button
					type="button"
					className="bottom-nav-item"
					aria-label="Home"
					onClick={() => navigate('/')}
				>
					<FaMapMarkerAlt />
				</button>
				<NotificationsMenu fullscreen triggerClassName="bottom-nav-item" triggerIcon={<FaBell />} onOpenChange={setNotificationsOpen} />
				<UserAccountMenu fullscreen triggerClassName="bottom-nav-item" triggerIcon={<FaUser />} onOpenChange={setProfileOpen} />
			</nav>
			<div className={`mobile-menu-sheet ${menuOpen ? 'open' : ''}`}>
				<div className="mobile-menu-sheet-header">
					<button
						type="button"
						className="mobile-menu-sheet-close"
						title="Close"
						onClick={() => setMenuOpen(false)}
					>
						<IoIosClose aria-hidden="true" />
						<span className="sr-only">Close</span>
					</button>
				</div>
				<div className="mobile-menu-sheet-body">
					<SideMenuList open onItemClick={() => setMenuOpen(false)} />
				</div>
			</div>
		</>
	)
}

export default MobileBottomNav;
